import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { ThemeProvider } from '@emotion/react';
import { PAYPAL_THEME } from '@paypalcorp/pp-react';
import SessionHandler from '../../home/containers/SessionHandler';
import ContactUsPage from '../containers/pages/ContactUsPage';
import { generateLinkData, trackImpression } from '../../helpers/analytics/fptiHelper';
import { contactUsFPTIs } from '../../helpers/analytics/contactUsPageAnalytics';
import { pageNames } from '../../common/constants';
import { redirectLocation } from '../../../js/contactUs/actions/action-contact-location';

// PP-REACT

const ContactUsApp = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    trackImpression({
      ...contactUsFPTIs.contactUsPageLoading,
      link: generateLinkData(contactUsFPTIs.contactUsPageLoading.link),
    });
    dispatch(redirectLocation({ pageName: pageNames.CONTACT_US }));
  }, []);

  const renderContactUsComponent = () => {
    return (
      <div className="sh_root__container" data-testid="sh-root-container">
        <div className="vx_mainContent" role="main">
          <SessionHandler />
          <ThemeProvider theme={PAYPAL_THEME}>
            <div className="sh_root__content__container" data-testid="sh-root-content-container">
              <ContactUsPage />
            </div>
          </ThemeProvider>
        </div>
      </div>
    );
  };

  const contactUsPageContainer = () => <div>{renderContactUsComponent()}</div>;
  return contactUsPageContainer();
};

ContactUsApp.PropTypes = {
  children: PropTypes.element.isRequired,
};
export default ContactUsApp;
